import React from 'react';

export const PricingErrorContext = React.createContext({
  pricingErrors: {},
  pricingTouched: {},
  setPricingErrors: () => {},
  setPricingTouched: () => {},
});
